import { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { NAV } from '../data/content.js'

export default function Header() {
  const { t, i18n } = useTranslation()
  const [menuOpen, setMenuOpen] = useState(false)
  const activeLng = i18n.resolvedLanguage?.split('-')[0]

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  // Escape мобильді менюді жабады
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  return (
    <header className="header">
      <div className="container header-inner">
        <Link to="/" className="brand-row" aria-label="Almus — басты бет">
          <img src="/images/almus-logo.png" alt="Almus — ТОО «Перспективные материалы и технологии»" className="brand-logo" />
          <span className="brand-divider" aria-hidden="true" />
          <img src="/images/science-fund.png" alt="Ғылым қоры / Фонд науки" className="fund-logo" />
        </Link>

        <nav className="nav">
          {NAV.map((item) => (
            <NavLink key={item.path} to={item.path} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              {t(item.labelKey)}
            </NavLink>
          ))}
        </nav>

        <div className="header-actions">
          <div className="lang-switcher" role="group" aria-label={t('contact.ariaLanguage')}>
            {['kk', 'ru', 'en'].map((lng) => (
              <button
                key={lng}
                className={activeLng === lng ? 'active' : ''}
                onClick={() => changeLanguage(lng)}
              >
                {lng.toUpperCase()}
              </button>
            ))}
          </div>
          <Link to="/contact" className="btn btn-primary">{t('hero.cta')}</Link>
          <button
            type="button"
            className="menu-toggle"
            aria-expanded={menuOpen}
            aria-label={t('contact.ariaMenu')}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        <nav className="nav">
          {NAV.map((item) => (
            <NavLink key={item.path} to={item.path} className="nav-link" onClick={() => setMenuOpen(false)}>
              {t(item.labelKey)}
            </NavLink>
          ))}
        </nav>
        <div className="lang-switcher">
          {['kk', 'ru', 'en'].map((lng) => (
            <button
              key={lng}
              className={activeLng === lng ? 'active' : ''}
              onClick={() => changeLanguage(lng)}
            >
              {lng.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
    </header>
  )
}